<script setup>
  import { computed } from 'vue'
  const props = defineProps({
    items: {
      type: Array,
      required: false
    },
    itemsString: {
      type: String,
      required: false
    }
  })

  const itemIds = computed(() => {
    if (props.itemsString) {
      const ids = JSON.parse(props.itemsString)
      return ids.join(',')
    }
    return props.items.map(item => {
      return item.id
    }).join(',')
  })
</script>

<template>
  <div>
    <a
      :href="`/export/pdf/events?ids=${itemIds}`"
      target="_blank"
      class="text-primary text-sm flex flex-row w-fit pb-1 items-center gap-2 mb-4 border-primary border-b border-opacity-0 hover:border-opacity-100 transition-all"
    >
      <AppIcon
        name="Download"
      />
      {{ props.itemsString ? 'Termine als PDF Exportieren' : 'Ergebnis Ihrer Auswahl als PDF exportieren' }}
    </a>
  </div>
</template>

<style lang="scss" scoped>
  :deep(svg) {
    @apply h-4 w-4;
  }
  :deep(svg path) {
    @apply fill-primary !important;
  }
</style>

